module.exports = __webpack_public_path__ + "static/media/students.49ef64a4.svg";